// extracted by mini-css-extract-plugin
module.exports = {"animated-title":"TitleAnimation_animated-title__2IlEa","animated-title__word":"TitleAnimation_animated-title__word__X956L"};